import { render, staticRenderFns } from "./DownloadQuote.vue?vue&type=template&id=00522286&"
import script from "./DownloadQuote.vue?vue&type=script&lang=js&"
export * from "./DownloadQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports